export const VCS_JOIN_POLICY = {
    ALL: 'WITHOUT_RESTRICTIONS',
    GUESTS_WITH_APPROVAL: 'REQUIRED_FOR_GUESTS',
    ALL_WITH_APPROVAL: 'REQUIRED_FOR_EVERYONE',
} as const;

export type VcsJoinPolicy = (typeof VCS_JOIN_POLICY)[keyof typeof VCS_JOIN_POLICY];

const VALID_JOIN_POLICIES = new Set<VcsJoinPolicy>(Object.values(VCS_JOIN_POLICY));

export const normalizeJoinPolicy = (value?: string | null): VcsJoinPolicy =>
    value != null && VALID_JOIN_POLICIES.has(value as VcsJoinPolicy) ? (value as VcsJoinPolicy) : VCS_JOIN_POLICY.ALL;
